import { render, staticRenderFns } from "./DesignBaseInput.vue?vue&type=template&id=663574bb&"
import script from "./DesignBaseInput.vue?vue&type=script&lang=js&"
export * from "./DesignBaseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports